import Base from 'app/collections/base';
import { fulfillmentUrl } from 'utils/wrappers';
import FulfillmentInventory from 'app/models/fulfillment_inventory';

let inventoryCache = {};

export default Base.extend({
  model: FulfillmentInventory,
  url: fulfillmentUrl('inventories'),

  initialize(models, { apiMode }) {
    this.apiMode = apiMode;
  },

  fetch(options = {}) {
    // if there are no product ids, don't do anything.
    if (!options.productIds || !options.productIds.length) {
      return;
    }

    // filter out ids already loaded, so we make the smallest request possible.
    const ids = options.productIds.filter(id => !inventoryCache[id]);

    // if all of the products are already loaded into cache, reset the
    // collection from the cache.
    if (!ids.length) {
      this.reset(options.productIds.map(id => ({ product_id: id, inventory: inventoryCache[id] })));
      this.trigger('sync');
      return;
    }

    // put dummy objects into the cache for now, so we don't request the same
    // ids simultaneously if we fetch the collection again
    Object.keys(ids).forEach(id => inventoryCache[id] = {});

    Base.prototype.fetch.call(this, { data: { product_ids: ids } });
  },

  paramsForFetch() {
    return {
      mode: this.apiMode.get('mode'),
    };
  },

  parse(response) {
    // load the response into the cache by id
    inventoryCache = {
      ...inventoryCache,
      ...response,
    };

    // turn the map into an object that works better with the collection
    // { prod_a: { warehouse_a: 1 } } becomes
    // [{ product_id: prod_a, warehouse_a: 1 }]
    return Object.keys(response).reduce((o, k) => {
      o.push({ inventory: response[k], product_id: k });
      return o;
    }, []);
  }
});



// WEBPACK FOOTER //
// ./app/collections/fulfillment_inventory.js